import { createContext, useContext } from "react";

/**
 * The element a dashboard page scrolls in. The dashboard layout is exactly
 * the window's height and only its `<main>` scrolls, so the sidebar and
 * header never move - not even when macOS rubber-bands a fast scroll, which
 * carried a sticky sidebar with it while the window was the scroller.
 *
 * `null` outside the layout (a page rendered on its own, as in a unit test),
 * where the window is still the scroller.
 */
export const PageScrollerContext = createContext<HTMLElement | null>(null);

export function usePageScroller(): HTMLElement | null {
  return useContext(PageScrollerContext);
}

/** How far the page is scrolled, wherever it scrolls. */
export function pageScrollTop(scroller: HTMLElement | null): number {
  return scroller ? scroller.scrollTop : window.scrollY;
}
